import { SubscriptionPlan, SubscriptionServiceConfig } from '../types/subscription';

export const SUBSCRIPTION_SERVICE: SubscriptionServiceConfig = {
  productName: 'GamesHUB',
  serviceId: '2680120000007097',
  shortCode: '99951',
  subscriptionProviderId: 'CSM',
  currency: 'SZL',
};

const BASE_FEATURES = [
  'Unlimited Games',
  'HD Quality',
  'Mobile Access',
  'Ad-Free Experience',
];

export const SUBSCRIPTION_PLANS: SubscriptionPlan[] = [
  {
    id: 'daily',
    subscriptionId: '26801220000007221',
    name: 'GamesHUB Daily',
    description: 'Daily',
    duration: '1 Day',
    durationDays: 1,
    price: 0.1,
    features: BASE_FEATURES,
  },
  {
    id: '2-days',
    subscriptionId: '26801220000007822',
    name: 'GamesHUB2Days',
    description: '2 Days',
    duration: '2 Days',
    durationDays: 2,
    price: 1,
    features: [...BASE_FEATURES, 'Early Access'],
  },
  {
    id: '5-days',
    subscriptionId: '26801220000007821',
    name: 'GamesHUB5Days',
    description: '5 Days',
    duration: '5 Days',
    durationDays: 5,
    price: 2.5,
    features: [...BASE_FEATURES, 'Early Access', 'Priority Support'],
    discountLabel: 'Best Value',
  },
  {
    id: 'weekly',
    subscriptionId: '26801220000007220',
    name: 'GamesHUBWeekly',
    description: 'Weekly',
    duration: '7 Days',
    durationDays: 7,
    price: 10,
    features: [...BASE_FEATURES, 'Early Access', 'All Devices'],
  },
  {
    id: 'monthly',
    subscriptionId: '26801220000007219',
    name: 'GamesHUBMonthly',
    description: 'Monthly',
    duration: '30 Days',
    durationDays: 30,
    price: 20,
    features: [
      ...BASE_FEATURES,
      '4K Quality',
      'All Devices',
      'Exclusive Content',
      'Priority Support',
    ],
    badge: 'most-popular',
  },
];

export const getSubscriptionPlanById = (id: string): SubscriptionPlan | undefined =>
  SUBSCRIPTION_PLANS.find((plan) => plan.id === id);

export const getSubscriptionPlanBySubscriptionId = (
  subscriptionId: string
): SubscriptionPlan | undefined =>
  SUBSCRIPTION_PLANS.find((plan) => plan.subscriptionId === subscriptionId);
